/*
 * Where: src/constants/topPageContent.js
 * What: Static content for the service top page.
 * Why: Separate copy from UI rendering for maintainability.
 */

export const TOP_HERO = {
    badge: '自宅確認サービス',
    title: '自宅で受けられる行政サービスを確認できます。',
    description:
        '本サービスは、個人が自宅でマイナンバーカードを読み取り、受けられる行政サービス候補を確認するデモです。' +
        ' 申請手続きは行わず、確認のみに対応します。',
};

export const VALUE_POINTS = [
    {
        title: '自宅で事前確認',
        text: '役所へ行く前に、対象となる行政サービス候補を把握できます。',
    },
    {
        title: '確認専用設計',
        text: 'このサービスでは申請は行わず、候補確認に用途を限定しています。',
    },
    {
        title: '個人向け表示',
        text: '読み取り結果から、個人に関連する支援情報のみを表示します。',
    },
];

export const INTRO_FLOW = [
    'NFC Bridge拡張機能とNative Hostを設定する',
    'USB NFC4リーダーを自宅PCへ接続する',
    'マイナンバーカードを読み取り、カードIDを取得する',
    '受けられる行政サービス候補を一覧で確認する（申請は未対応）',
];
